<form #form [formGroup]="formGroup" (ngSubmit)="submitForm()">
  <span class="form-header mb-3" i18n>Which group of accounts does this submission apply to?</span>
  <div class="account-type-container">
    <label class="dropdown-label" id="accountTypeLabel" for="accountType" i18n>Account Type</label>
    <app-dropdown-input
      formControlName="accountType"
      [controlId]="'accountType'"
      [name]="'accountType'"
      [labelId]="'accountTypeLabel'"
      [error]="formGroup.controls.accountType.invalid && formSubmitted"
      [dropdowns]="accountTypeDropdowns$ | async" />
    <app-form-error
      *ngIf="formGroup.controls.accountType.invalid && formSubmitted"
      class="mt-2"
      [errors]="formGroup.controls.accountType.errors"
      [customErrorMessages]="accountTypeErrorMessages" />
  </div>
  <span class="form-header mb-4" i18n>What is the nature of the member’s submission?</span>
  <div class="submission-type-container">
    <div class="radio-container">
      <app-radio-button-input
        formControlName="submissionType"
        [controlId]="'rebalance'"
        [value]="ChangeInvestmentInstructionSubmissionTypeEnum.Rebalance"
        [name]="'submissionType'" />
      <div class="radio-text-container">
        <app-form-option-label [labelFor]="'rebalance'" i18n>Rebalance Accumulated Funds</app-form-option-label>
        <span class="radio-subtext" i18n>
          Update how the existing balance is allocated among the investment funds.
        </span>
      </div>
    </div>
    <div class="radio-container">
      <app-radio-button-input
        formControlName="submissionType"
        [controlId]="'adjust'"
        [value]="ChangeInvestmentInstructionSubmissionTypeEnum.AdjustFutureContributions"
        [name]="'submissionType'" />
      <div class="radio-text-container">
        <app-form-option-label [labelFor]="'adjust'" i18n>Adjust Investment Instructions</app-form-option-label>
        <span class="radio-subtext" i18n>
          Update how the upcoming contributions or deposits will be distributed among the funds.
        </span>
      </div>
    </div>
  </div>
  <app-form-error
    *ngIf="formGroup.controls.submissionType.invalid && formSubmitted"
    class="d-block mt-4"
    [errors]="formGroup.controls.submissionType.errors"
    [customErrorMessages]="submissionTypeErrorMessages" />
</form>
